export default __webpack_public_path__ + "static/media/undraw_wallet.683de8a9.svg";